import React from 'react';
import { useState, useEffect } from 'react';
import { Menu, Search } from 'lucide-react';
import NotificationsDropdown from './header/NotificationsDropdown';
import UserDropdown from './header/UserDropdown';
import { authService } from '../../features/auth/services/authService';



const Header = ({ title, setSidebarOpen }) => {
  const [user, setUser] = useState(null);
  const [notifications, setNotifications] = useState([
   
  ]);

  useEffect(() => {
    // Charger les informations de l'utilisateur connecté
    const loadUser = async () => {
      try {
        const userData = await authService.getCurrentUser();
        setUser(userData?.admin);
      } catch (error) {
        console.error("Erreur lors du chargement de l'utilisateur:", error);
      }
    };

    loadUser();
  }, []);

  const handleLogout = async () => {
    try {
      await authService.logout();
      // Rediriger vers la page de connexion ou rafraîchir l'application
      window.location.href = '/login';
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);
    }
  };

  const handleLogoutAll = async () => {
    try {
      await authService.logoutAll();
      // Rediriger vers la page de connexion ou rafraîchir l'application
      window.location.href = '/login';
    } catch (error) {
      console.error("Erreur lors de la déconnexion de tous les appareils:", error);
    }
  };

  return (
    <header className="bg-white shadow-sm z-10">
      <div className="px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <button
              className="lg:hidden mr-2"
              onClick={() => setSidebarOpen(true)}
            >
              <Menu className="w-6 h-6 text-gray-500" />
            </button>
            <h1 className="text-xl font-semibold text-gray-800">{title}</h1>
          </div>
          <div className="flex items-center space-x-14">
            <div className="relative">
              {/* <input
                type="text"
                placeholder="Rechercher..."
                className="form-input px-10 py-2 text-sm rounded-full"
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="w-5 h-5 text-gray-400" />
              </div> */}
            </div>
            
            <NotificationsDropdown 
              notifications={notifications} 
              setNotifications={setNotifications} 
            />
            
            <UserDropdown 
              user={user} 
              onLogout={handleLogout}
              onLogoutAll={handleLogoutAll}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;